import * as z from "zod";

export const getMessagingGroups = {
  name: "getMessagingGroups" as const,
  input: z.object({}),
  output: z.object({
    groups: z.array(
      z.object({
        _id: z.string(),
        name: z.string(),
        channelIds: z.array(z.string()),
        createdAt: z.date(),
        updatedAt: z.date(),
      }),
    ),
  }),
};
